// extracted by mini-css-extract-plugin
module.exports = {"TextWithLink":"styles_TextWithLink___IkzK typography_TextWithLink__AvI5e"};